import React, { useEffect, useMemo } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useSalonBrand } from './useSalonBrand'
import { SmoothEmailFrame } from './SmoothEmailFrame'
import { resolveTheme, LOOKS } from '../email-composer/email/theme'
import { previewHtml, fontName, BRAND_PAGE, CONFIG_PAGE } from './brandPreview'
import { hapticTick } from '../../../../_utils/haptics'
import '../email-composer/EmailBuilder.css'
import './BrandCard.css'

// Marketing > Config: the salon's brand at a glance. How an email opens and
// what it's made of; editing happens on its own page (Your brand), with the
// preview held beside the controls.

export const BrandCard = () => {
  const brand = useSalonBrand()
  const history = useHistory()
  const location = useLocation()
  const theme = resolveTheme(brand.spec)
  const html = useMemo(() => previewHtml(brand.spec), [brand.spec])

  // Older links (#brand) meant "edit the brand": that's the page now
  useEffect(() => {
    if (location.hash === '#brand') history.replace(BRAND_PAGE)
  }, [location.hash]) // eslint-disable-line react-hooks/exhaustive-deps

  // Opened below Config, so its Back comes back here
  const open = () => { hapticTick(); history.push(BRAND_PAGE, { from: CONFIG_PAGE }) }
  const look = LOOKS[theme.look]
  const accent = theme.palette.accent

  return (
    <section className="brc" id="brand">
      <div className="brc-head">
        <div>
          <div className="brc-title-row">
            <h5 className="brc-title">Your brand</h5>
            {!brand.loading && !brand.isSet && <span className="brc-badge">Not set up yet</span>}
          </div>
          <p className="brc-sub">Every email starts with this. Your logo and colour also appear on your booking emails.</p>
        </div>
        <button type="button" className={`brc-btn brc-btn--head ${brand.isSet ? '' : 'brc-btn--primary'}`} onClick={open}>
          {brand.isSet ? 'Edit brand' : 'Set up your brand'}
        </button>
      </div>

      <div className="brc-body">
        <button type="button" className="brc-preview" onClick={open} aria-label="Open your brand">
          <span className="brc-preview-stage" style={{ background: theme.palette.canvas }}>
            {brand.loading ? <span className="brc-skeleton" /> : <SmoothEmailFrame html={html} width={600} title="Your brand in an email" />}
          </span>
        </button>

        <dl className="brc-facts">
          <div className="brc-fact">
            <dt>Logo</dt>
            <dd>
              {theme.logo
                ? <img src={theme.logo} alt="" className={`brc-logo ${theme.logoShape !== 'natural' ? `is-${theme.logoShape}` : ''}`} />
                : <span className="brc-muted">Your salon name instead</span>}
            </dd>
          </div>
          <div className="brc-fact">
            <dt>Colour</dt>
            <dd><span className="brc-swatch" style={{ background: accent }} />{accent}</dd>
          </div>
          <div className="brc-fact">
            <dt>Type</dt>
            <dd>
              {fontName(theme.type.display)}
              <span className="brc-muted"> and </span>
              {fontName(theme.type.text)}
            </dd>
          </div>
          <div className="brc-fact">
            <dt>Look</dt>
            <dd>{look ? look.name : 'Classic'}</dd>
          </div>
        </dl>
        {/* On a phone the button follows the details, as the way on from them */}
        <button type="button" className={`brc-btn brc-btn--foot ${brand.isSet ? '' : 'brc-btn--primary'}`} onClick={open}>
          {brand.isSet ? 'Edit brand' : 'Set up your brand'}
        </button>
      </div>
    </section>
  )
}

export default BrandCard
